/* @flow */
import * as React from 'react';

import BirthdateModalSection from 'chat/components/BirthdateModalSection';
import BirthdateSelector from './BirthdateSelector';
import ToastActions from 'actions/ToastActions';
import UserActions from 'user/UserActions';

class AskForBirthdate extends React.Component<{}, { birthdate?: Date }> {
  state: { birthdate?: Date } = {
    birthdate: undefined,
  };

  onSubmit = () => {
    if (!this.state.birthdate) {
      console.error('ignoring birthdate form submission with null birthdate');
      return;
    }

    const onError = response => {
      const errors = {};

      for (const field of response['field_errors']) {
        errors[field['field_name']] = field.messages.join(', ');
      }

      if ('birthdate' in errors) {
        ToastActions.showErrorToast(errors['birthdate']);
      }
    };

    UserActions.setBirthdate(this.state.birthdate).then(() => {}, onError);
  };

  birthdateChanged = (birthdate: Date) => {
    this.setState({ birthdate });
  };

  buttonDisabled = () => {
    return !this.state.birthdate;
  };

  renderCollector = () => {
    return <BirthdateSelector onChange={this.birthdateChanged} />;
  };

  render() {
    return (
      <BirthdateModalSection
        title="What is your date of birth?"
        renderCollector={this.renderCollector}
        buttonDisabled={this.buttonDisabled}
        onSubmit={this.onSubmit}
      />
    );
  }
}

export default AskForBirthdate;
